import { appendHeadersWithJSONContentType, customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8PartnerDTO, M8PartnerInfo } from 'services/production/types';

type Params = {
  partnerInfo: M8PartnerInfo;
  idPartner: number;
};

export const updatePartnerInfo = async (
  params: Params
): Promise<M8PartnerDTO> => {
  const { idPartner, partnerInfo } = params;

  const body = JSON.stringify(partnerInfo);

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(
    getM8AdminURL(`updatePartnerInfo/${idPartner}`),
    {
      method: 'PUT',
      body,
      headers,
    }
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
